import { getLandingPageShadowRoot } from 'js/src/libs/shadow-dom/landing-page-shadow-root';

/**
 * style-loader's `insert` target for modules in the `shadow-dom` rspack layer (see
 * rspack.config.common.js): their CSS goes into the landing page shadow root instead of
 * document.head.
 */
const insertStyleIntoShadowRoot = (style: HTMLElement) => {
    getLandingPageShadowRoot().appendChild(style);
};

export default insertStyleIntoShadowRoot;
